// @flow
import memoize from 'mz-utils/memoize'
import client from '../../client'

// Types
export type Currency = {
  code: string,
  name: string,
  type: string,
}

// Constants
export const CURRENCY_ENDPOINT = '/currencies/'

/**
 * Returns all Currencies
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getAll = memoize((): Promise<Currency[]> =>
  client.get(CURRENCY_ENDPOINT).then((response) =>
    response.currencies.map((currency) => ({
      code: currency.code,
      name: currency.name,
      type: currency.support_level,
    }))
  )
)

export default getAll
